/**
 * @generated SignedSource<<a9845b0b08f0b77c816b7fc15413e6ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ServicesManagerDoorAccessLevel = "ALL" | "DENIALS_ONLY" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type controlSystemServicesModel_servicesManager$data = {
  readonly armingAppEnabled: boolean;
  readonly digitalWatchdogSpectrumEnabled: boolean;
  readonly dmpVideoEnabled: boolean;
  readonly doorAccessLevel: ServicesManagerDoorAccessLevel;
  readonly doorsEditingEnabled: boolean;
  readonly eagleEyeEnabled: boolean;
  readonly favoriteEditingEnabled: boolean;
  readonly fullAppEnabled: boolean;
  readonly hikvisionNvrEnabled: boolean;
  readonly lightControlEnabled: boolean;
  readonly lockControlEnabled: boolean;
  readonly openEyeEnabled: boolean;
  readonly outputOptionsEditingEnabled: boolean;
  readonly realTimeEventsEnabled: boolean;
  readonly ringDoorbellEnabled: boolean;
  readonly scheduleEditEnabled: boolean;
  readonly sensorActivityEnabled: boolean;
  readonly storeUserCodes: boolean;
  readonly thermostatControlEnabled: boolean;
  readonly trafficCountEnabled: boolean;
  readonly userCodeEditingEnabled: boolean;
  readonly varEnabled: boolean | null;
  readonly vueCamerasEnabled: boolean | null;
  readonly vueDoorbellsEnabled: boolean | null;
  readonly zwaveNodeEditingEnabled: boolean;
  readonly " $fragmentType": "controlSystemServicesModel_servicesManager";
};
export type controlSystemServicesModel_servicesManager$key = {
  readonly " $data"?: controlSystemServicesModel_servicesManager$data;
  readonly " $fragmentSpreads": FragmentRefs<"controlSystemServicesModel_servicesManager">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "controlSystemServicesModel_servicesManager"
};

(node as any).hash = "2c67f20a8429f50e4eee79dd3a849974";

export default node;
